import { PREVIOUS_SSO_SOURCE } from "./constants"

export const setPreviousSSOSource = (source: string) => {
  sessionStorage.setItem(PREVIOUS_SSO_SOURCE, source)
}

export const getPreviousSSOSource = () => {
  return sessionStorage.getItem(PREVIOUS_SSO_SOURCE)
}

export const removePreviousSSOSource = () => {
  sessionStorage.removeItem(PREVIOUS_SSO_SOURCE)
}
